import { Flex } from "@chakra-ui/react";

import NotifyForm from "./notify-form";
import PastEvents from "./past-events";
import UpcomingEvent from "./upcoming-event";
const Events = () => {
  return (
    <Flex align={"start"} direction={"column"} fontFamily={"'Inter', sans-serif"}>
      <UpcomingEvent />
      <PastEvents />
      <NotifyForm />
    </Flex>
  );
};
export default Events;
